/* Lavender Farm Simulator — Greenhouse & Flower Farm upgrade.
   - Greenhouse bays show the game's painted bay artwork for each stage (empty, propagation, young, mature),
     locked bays show a rolling bench waiting to be installed.
   - Flower Farm beds show the painted bed for the crop actually planted (zinnia, sunflower, cosmos,
     snapdragon, celosia, dahlia, or mixed annuals), growing in as the crop matures.
   - Each workspace gets a painted header and the same drag-and-drop tool belt as the Lavender Field.
   Reads the game's own markup; clicks go through the game's own buttons. Never edits the save. */
(function () {
  'use strict';
  if (window.__gllfSimWorkspaces) return;
  window.__gllfSimWorkspaces = true;
  var BASE = ((document.currentScript && document.currentScript.src) || '').replace(/gllf-sim-workspaces\.js.*$/, '');
  function art(id) { return BASE + 'gllf-art-' + id + '.webp'; }

  /* ---------- Greenhouse bays ---------- */
  function ghArt(bed) {
    if (bed.classList.contains('locked')) return 'rolling-bench';
    if (bed.classList.contains('empty')) return 'empty-greenhouse-bay';
    var m = String(bed.className).match(/stage-(\d)/), s = m ? +m[1] : 1;
    return s <= 2 ? 'propagation-greenhouse-bay' : s === 3 ? 'young-plant-greenhouse-bay' : 'mature-greenhouse-bay';
  }
  function decorateGh(view) {
    view.querySelectorAll('.lfg-gh-beds [data-gh-bed]').forEach(function (bed) {
      var id = ghArt(bed), im = bed.querySelector(':scope > img.gws-art');
      var health = (bed.getAttribute('aria-label') || '').match(/health (\d+)/);
      bed.classList.toggle('gws-stressed', !!health && +health[1] < 45);
      if (im && im.getAttribute('data-id') === id) return;
      if (!im) { im = document.createElement('img'); im.className = 'gws-art'; im.alt = ''; im.setAttribute('aria-hidden', 'true'); im.decoding = 'async'; bed.insertBefore(im, bed.firstChild); }
      im.setAttribute('data-id', id); im.src = art(id);
      bed.classList.add('gws-bay');
    });
  }

  /* ---------- Flower Farm beds ---------- */
  var CF = { zinnia: 'cut-flower-bed-zinnia', sunflower: 'cut-flower-bed-sunflower', cosmos: 'cut-flower-bed-cosmos', snapdragon: 'cut-flower-bed-snapdragon', celosia: 'cut-flower-bed-celosia', dahlia: 'cut-flower-bed-dahlia' };
  function decorateCf(view) {
    view.querySelectorAll('[data-cf-bed]').forEach(function (bed) {
      var empty = bed.classList.contains('empty');
      var name = ((bed.querySelector('b') || {}).textContent || '').toLowerCase().trim();
      var key = Object.keys(CF).filter(function (k) { return name.indexOf(k) === 0; })[0];
      var em = bed.querySelector('i > em'), grow = em ? Math.min(100, parseFloat(em.style.width) || 0) : 0;
      var id = empty || grow < 30 ? 'cut-flower-bed-empty-prepared' : (CF[key] || 'cut-flower-bed-mixed-annuals');
      bed.style.setProperty('--gws-grow', empty ? '1' : String(.55 + Math.min(1, grow / 100) * .45));
      bed.classList.toggle('gws-sprouting', !empty && grow < 30);
      var im = bed.querySelector(':scope > img.gws-art');
      if (im && im.getAttribute('data-id') === id) return;
      if (!im) { im = document.createElement('img'); im.className = 'gws-art'; im.alt = ''; im.setAttribute('aria-hidden', 'true'); im.decoding = 'async'; bed.insertBefore(im, bed.firstChild); }
      im.setAttribute('data-id', id); im.src = art(id);
      bed.classList.add('gws-bed');
    });
  }

  /* ---------- painted headers ---------- */
  function header(view, id) {
    var head = view.querySelector(':scope > .lfg-page-head');
    if (!head || head.querySelector('.gws-banner')) return;
    var b = document.createElement('img'); b.className = 'gws-banner'; b.src = art(id); b.alt = ''; b.setAttribute('aria-hidden', 'true');
    head.classList.add('gws-head'); head.appendChild(b);
  }

  /* ---------- tool belts (same look and behavior as the Lavender Field belt) ---------- */
  function belt(view, cfg) {
    var grid = view.querySelector(cfg.grid); if (!grid) return;
    var tools = view.querySelectorAll(cfg.tool); if (!tools.length) return;
    var el = grid.previousElementSibling && grid.previousElementSibling.classList.contains('gllf-belt') ? grid.previousElementSibling : null;
    if (!el) {
      el = document.createElement('div'); el.className = 'gllf-belt gws-belt'; el.setAttribute('role', 'toolbar');
      el.setAttribute('aria-label', cfg.label + ' tools. Drag a tool onto a ' + cfg.noun + ', or pick a tool and tap a ' + cfg.noun + '.');
      grid.parentElement.insertBefore(el, grid);
      wire(view, el, cfg, grid);
    }
    var sig = Array.prototype.map.call(tools, function (t) { return t.getAttribute(cfg.attr) + (t.classList.contains('active') ? '*' : ''); }).join(',');
    if (el.getAttribute('data-sig') === sig) return;
    el.setAttribute('data-sig', sig);
    el.innerHTML = '<span class="gllf-belt__label" aria-hidden="true">Tools</span><div class="gllf-belt__tools">' + Array.prototype.map.call(tools, function (t) {
      var id = t.getAttribute(cfg.attr), on = t.classList.contains('active');
      var icon = (t.childNodes[0] && t.childNodes[0].nodeType === 3 ? t.childNodes[0].textContent : (t.querySelector('span') || {}).textContent || '•').trim();
      var name = ((t.querySelector('b') || {}).textContent || t.textContent.replace(icon, '')).trim();
      return '<button type="button" class="gllf-belt__tool' + (on ? ' is-on' : '') + '" aria-pressed="' + on + '" data-ws-tool="' + id + '"><span class="gllf-belt__icon" aria-hidden="true">' + icon + '</span><span class="gllf-belt__name">' + name + '</span></button>';
    }).join('') + '</div>';
  }
  function wire(view, el, cfg, grid) {
    function pick(id) { var t = view.querySelector(cfg.tool.replace(/\]$/, '') + '="' + id + '"]') || Array.prototype.filter.call(view.querySelectorAll(cfg.tool), function (x) { return x.getAttribute(cfg.attr) === id; })[0]; if (t) t.click(); }
    el.addEventListener('click', function (e) { var b = e.target.closest('[data-ws-tool]'); if (!b) return; pick(b.getAttribute('data-ws-tool')); el.removeAttribute('data-sig'); });
    var drag = null;
    function target(x, y) { var n = document.elementFromPoint(x, y); var t = n && n.closest(cfg.target); return t && !t.classList.contains('locked') && t.getAttribute('aria-disabled') !== 'true' ? t : null; }
    el.addEventListener('pointerdown', function (e) { var b = e.target.closest('[data-ws-tool]'); if (!b || e.button > 0) return; drag = { id: b.getAttribute('data-ws-tool'), x: e.clientX, y: e.clientY, src: b }; });
    window.addEventListener('pointermove', function (e) {
      if (!drag) return;
      if (!drag.moved && Math.hypot(e.clientX - drag.x, e.clientY - drag.y) < 8) return;
      if (!drag.moved) { drag.moved = true; drag.ghost = document.createElement('div'); drag.ghost.className = 'gllf-belt__ghost'; drag.ghost.textContent = drag.src.querySelector('.gllf-belt__icon').textContent; document.body.appendChild(drag.ghost); grid.classList.add('gws-dragging'); }
      e.preventDefault();
      drag.ghost.style.transform = 'translate(' + (e.clientX - 22) + 'px,' + (e.clientY - 22) + 'px)';
      var t = target(e.clientX, e.clientY);
      if (t !== drag.over) { if (drag.over) drag.over.classList.remove('gws-over'); if (t) t.classList.add('gws-over'); drag.over = t; }
    }, { passive: false });
    function end(e) {
      if (!drag) return; var d = drag; drag = null;
      grid.classList.remove('gws-dragging'); if (d.ghost) d.ghost.remove(); if (d.over) d.over.classList.remove('gws-over');
      if (!d.moved || !e || e.type !== 'pointerup') return;
      var t = target(e.clientX, e.clientY); if (!t) return;
      pick(d.id); setTimeout(function () { t.click(); }, 40);
    }
    window.addEventListener('pointerup', end); window.addEventListener('pointercancel', end);
  }

  var GH = { grid: '.lfg-gh-beds', tool: '.lfg-gh-tools [data-gh-tool]', attr: 'data-gh-tool', target: '.lfg-gh-beds [data-gh-bed]', label: 'Greenhouse', noun: 'bay' };
  var CFB = { grid: '.lfg-cutflower-beds, [data-cf-bed]:first-child', tool: '[data-cf-tool]', attr: 'data-cf-tool', target: '[data-cf-bed]', label: 'Flower Farm', noun: 'bed' };

  function tick(root) {
    var gh = root.querySelector('section.lfg-view[data-view="greenhouse"]');
    if (gh && gh.querySelector('[data-gh-bed]')) { decorateGh(gh); header(gh, 'glass-greenhouse'); belt(gh, GH); }
    var cf = root.querySelector('section.lfg-view[data-view="cutflower"]');
    if (cf && cf.querySelector('[data-cf-bed]')) {
      decorateCf(cf); header(cf, 'mixed-flower-bed');
      var first = cf.querySelector('[data-cf-bed]'); if (first && !first.parentElement.classList.contains('gws-cf-grid')) first.parentElement.classList.add('gws-cf-grid');
      belt(cf, { grid: '.gws-cf-grid', tool: CFB.tool, attr: CFB.attr, target: CFB.target, label: CFB.label, noun: CFB.noun });
    }
  }
  var tries = 0;
  (function wait() {
    var root = document.getElementById('lfg-simulator-root');
    if (!root && document.readyState === 'complete') return;
    if (root && root._lfg) {
      tick(root);
      var pending = false;
      new MutationObserver(function () { if (pending) return; pending = true; requestAnimationFrame(function () { pending = false; tick(root); }); }).observe(root, { childList: true, subtree: true });
      return;
    }
    if (++tries < 240) setTimeout(wait, 250);
  })();
})();
